import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=5f3bac66&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=5f3bac66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3bac66",
  null
  
)

export default component.exports